import { toast } from "react-toastify";
import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";
import { jwtDecode } from "jwt-decode";
// import { date } from "yup";

export const isLogin = () => {
  return localStorage.getItem("token") ? true : false;
};

export const getDecodedToken = () => {
  const token = localStorage.getItem("token") || "";
  if (!token) return {};
  const decoded = jwtDecode(token);
  return decoded;
};

export const hasBusiness = () => {
  let business = getDecodedToken();
  if (!business.businessId) return false;
  return true;
};

export const createUser = async (data) => {
  try {
    let resp = await http.post(URL + "/user/create", data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const sendEmail = async (data) => {
  try {
    let resp = await http.post(URL + "/user/verify-email", data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const checkUserBusiness = async (data) => {
  try {
    const fingerprint = data.fingerprint;
    // console.log("line 41 auth ser", data);
    let resp = await http.post(URL + "/user/check", data);
    return resp;
  } catch (error) {
    errorHandler(error);
    return error;
  }
};

export const loginUser = async (data) => {
  try {
    let resp = await http.post(URL + "/user/login", data);
    return resp;
  } catch (error) {
    errorHandler(error);
    return null;
  }
};

export const getUser = async (id) => {
  try {
    let resp = await http.get(URL + "/user/" + id);
    // console.log("line 61", resp);
    return resp;
  } catch (error) {
    // console.log("errr", error);
    errorHandler(error);
    // return error?.response;
  }
};
export const getBusiness = async (bussinessId) => {
  try {
    const bussiness = await http.get(`${URL}/business/${bussinessId}`);
    //  console.log("From auth api", bussiness);
    return bussiness;
  } catch (error) {
    console.log(error);
    errorHandler(error);
  }
};

export const updateUser = async (id, data) => {
  try {
    let resp = await http.put(URL + "/user/" + id, data);
    return resp;
  } catch (error) {
    console.log(error);
    errorHandler(error);
  }
};

export const getHolidayList = async (bussinessId, id) => {
  try {
    let resp = await http.get(`${URL}/${bussinessId}/user/${id}`);
    return resp;
  } catch (error) {
    errorHandler(error);
    return error?.response;
  }
};
export const updateHolidaysList = async (id, data) => {
  try {
    let resp = await http.put(`${URL}/business/${id}/holidays`, data);
    return resp;
  } catch (error) {
    console.error("Error updating holidays", error);
    throw error;
  }
};

export const uploadUserImage = async (id, data) => {
  // console.log("233", data);
  try {
    let resp = await http.put(URL + "/user/avatar/" + id, data);
    return resp;
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const sendForgetEmail = async (data) => {
  try {
    let resp = await http.post(URL + "/user/forget-password", data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const startTrial = async (data) => {
  try {
    let resp = await http.post(URL + "/user/start-trial", data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const createPayment = async (data) => {
  try {
    let resp = await http.post(URL + "/user/payment", data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const verifyPayment = async (data) => {
  try {
    let resp = await http.post(URL + "/user/verify", data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

// employee - login;
export const employeeLogin = async (data) => {
  try {
    let resp = await http.post(URL + "/user/employee-login", data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const createNewBusiness = async (data) => {
  try {
    const bussiness = await http.post(`${URL}/business/create`, data);
    return bussiness;
  } catch (error) {
    console.log(error);
    errorHandler(error);
  }
};

export const getAllBusiness = async (userUuid) => {
  try {
    const bussiness = await http.get(
      `${URL}/business/all-bussiness/${userUuid}`
    );
    return bussiness;
  } catch (error) {
    console.log(error);
    errorHandler(error);
  }
};

export const updateBussinessData = async (businessId, data) => {
  try {
    const bussiness = await http.put(`${URL}/business/${businessId}`, data);
    return bussiness;
  } catch (error) {
    console.log(error);
    errorHandler(error);
  }
};
export const deleteBussinessData = async (businessId, data) => {
  try {
    const bussiness = await http.delete(`${URL}/business/${businessId}`, data);
    return bussiness;
  } catch (error) {
    console.log(error);
    errorHandler(error);
  }
};

// Reseller functions
export const resellerLogin = async (data) => {
  try {
    let resp = await http.post(URL + "/user/reseller/login", data);
    return resp;
  } catch (error) {
    errorHandler(error);
    return error?.response;
  }
};

export const createReseller = async (data) => {
  try {
    let resp = await http.post(URL + "/user/reseller/register", data);
    return resp;
  } catch (error) {
    errorHandler(error);
    return error?.response;
  }
};
